import { createContext } from "react";

import {
    Benefit,
    RenderingDetails,
    RemovePlanConfirmationHalfCard,
    RemovePlanConfirmationHalfCardButton,
} from "@swiggy-private/cart-types";
import { TooltipContext } from "@super-ui/interfaces";

import { ImpressionSuperOneTapAddNudgePayload } from "@super-ui/interfaces/SwiggyOneAnalytics";

export interface SuperContextValue {
    showDetailsFromSuperFooter: (link?: string) => Promise<void>;
    restaurantId?: string;
    analyticsEvents: {
        onImpressionSuperNudge: (title: string, ctaText: string, subtitle?: string, link?: string) => void;
        onImpressionSuperOneTapAddNudge: (payload: ImpressionSuperOneTapAddNudgePayload) => void;
        onImpressionSuperChangePlan: (
            planName: string,
            ctaLink: string,
            planPrice: string,
            itemData: RenderingDetails,
        ) => void;
        onImpressionSuperOfferBadge: (offerText: string) => void;
        onImpressionSuperRemovePlanConfirmationHalfCard: ({
            savingsValue,
            title,
            message,
            subMessage,
            planId,
            variant,
            initialBillAmount,
            finalBillAmount,
        }: RemovePlanConfirmationHalfCard) => void;
        onImpressionSuperRemovePlanHalfCardBackButton: ({
            planName,
            planId,
            cta,
            variant,
            initialBillAmount,
            finalBillAmount,
        }: RemovePlanConfirmationHalfCardButton) => void;
        onImpressionSuperRemovePlanHalfCardRemoveButton: ({
            planName,
            planId,
            cta,
            variant,
            initialBillAmount,
            finalBillAmount,
        }: RemovePlanConfirmationHalfCardButton) => void;
        onClickRemoveSuper: (planId: string, planName: string, planPrice: string) => void;
        onClickSuperRemovePlanHalfCardBackButton: ({
            planName,
            planId,
            cta,
            variant,
            initialBillAmount,
            finalBillAmount,
        }: RemovePlanConfirmationHalfCardButton) => void;
        onClickSuperRemovePlanHalfCardRemoveButton: ({
            planName,
            planId,
            cta,
            variant,
            initialBillAmount,
            finalBillAmount,
        }: RemovePlanConfirmationHalfCardButton) => void;
        onImpressionSuperViewDetailsFooterWidget: (ctaText: string) => void;
        onClickSuperViewDetailsFooterWidget: (ctaText: string) => void;
        onImpressionSuperViewAllBenefitsCTA: (
            ctaText: string,
            ctaLink: string,
            TooltipContext?: TooltipContext,
        ) => void;
        onClickSuperViewAllBenefitsCTA: (ctaText: string, ctaLink: string, TooltipContext?: TooltipContext) => void;
        onImpressionSwiggyOneSavingsNudge?: (benefits: Benefit) => void;
        onImpressionSwiggyOneEOCompletionNudge?: (benefits: Benefit, restaurantId: string) => void;
        onClickSwiggyOneEOCompletioNudge?: (benefits: Benefit, restaurantId: string) => void;
        onFooterStripImpression?: (title: string, ctaText: string) => void;
    };
    extraOfferHandler?: () => void;
}

const DEFAULT_VALUE: SuperContextValue = {
    showDetailsFromSuperFooter: () => Promise.resolve(void 0),
    restaurantId: "",
    analyticsEvents: {
        onImpressionSuperNudge: () => void 0,
        onImpressionSuperOneTapAddNudge: () => void 0,
        onImpressionSuperChangePlan: () => void 0,
        onImpressionSuperOfferBadge: () => void 0,
        onImpressionSuperRemovePlanConfirmationHalfCard: () => void 0,
        onImpressionSuperRemovePlanHalfCardBackButton: () => void 0,
        onImpressionSuperRemovePlanHalfCardRemoveButton: () => void 0,
        onClickRemoveSuper: () => void 0,
        onClickSuperRemovePlanHalfCardBackButton: () => void 0,
        onClickSuperRemovePlanHalfCardRemoveButton: () => void 0,
        onImpressionSuperViewDetailsFooterWidget: () => void 0,
        onClickSuperViewDetailsFooterWidget: () => void 0,
        onImpressionSuperViewAllBenefitsCTA: () => void 0,
        onClickSuperViewAllBenefitsCTA: () => void 0,
        onImpressionSwiggyOneSavingsNudge: () => void 0,
        onImpressionSwiggyOneEOCompletionNudge: () => void 0,
        onClickSwiggyOneEOCompletioNudge: () => void 0,
        onFooterStripImpression: () => void 0,
    },
    extraOfferHandler: () => void 0,
};

export default createContext<SuperContextValue>(DEFAULT_VALUE);
